<div class="page-title-area">
    <img src="assets/images/service_banner.png" alt="Page Background" class="page-bg">
    <div class="container">
        <div class="page-title-content">
            <h2>Our Services</h2>
            <!-- <p>Superior Digital Private Limited is your trusted Apple Authorised Reseller. Receive expert advice on Apple products and accessories. We offer MDM solutions, Apple Business Manager for Automated Device Enrolment, Zero Touch Deployment, flexible financial options, and ongoing managed services. Enjoy configuration and deployment services for immediate use.</p> -->
        </div>
    </div>

    <!-- <div>
        <img src="assets/images/case-studies.png">
    </div> -->
  <!--   <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div> -->
</div>

<section class="home-case ptb-100 bg-color">
    <div class="container">
        <div class="section-title">
            <!-- <span>Case Studies</span> -->
            <!-- <span>Services</span> -->
            <span>Services</span>
            <h2>Our Services</h2>
            <!-- <p>At Superior Digital, we deliver technical, commercial, and operational expertise on a larger scale. Our dedicated Apple Practice supports various aspects of the broader Superior Digital business, ensuring that at every stage of the lifecycle, we are optimally positioned to assist enterprise organisations in adopting Apple technology and achieving their business goals.</p> -->
        </div>
        <div class="case">
            <div class="tabs-container">
                <div class="pane" id="tab1" *ngIf="currentTab === 'tab1'">
                    <div class="row case-list">
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/presales-support"><img src="assets/images/presales.jpeg" alt="case"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/presales-support"><h3>Apple Pre-Sales Expertise</h3></a>
                                    <p>Our expert team provides comprehensive pre-sales support to help you make informed decisions about Apple products and solutions for your business needs.</p>
                                    <a routerLink="/presales-support" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/demo"><img src="assets/images/pocdemo.jpeg" alt="case"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/demo"><h3>Apple Demos & Proof of Concept Solutions</h3></a>
                                    <p>Experience our hands-on demonstrations and proof of concept solutions to see how Apple technology can transform your business operations.</p>
                                    <a routerLink="/demo" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/buy-back"><img src="assets/images/ourservice_tradein.png" alt="case"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/buy-back"><h3>Apple Device Trade-In Program</h3></a>
                                    <p>Upgrade your Apple devices with our convenient trade-in program, offering competitive value for your existing equipment.</p>
                                    <a routerLink="/buy-back" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/onsite-support"><img src="assets/images/case/m6.png" alt="case"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/onsite-support"><h3>Apple Services with Expert Onsite Support</h3></a>
                                    <p>Our certified technicians provide expert onsite support for all your Apple devices, ensuring minimal downtime and maximum productivity.</p>
                                    <a routerLink="/onsite-support" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/partnering"><img src="assets/images/case/m5.png" alt="case"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/partnering"><h3>Strategic Partnerships with Leading Brands</h3></a>
                                    <p>We collaborate with top technology brands to provide comprehensive solutions that meet your business requirements.</p>
                                    <a routerLink="/partnering" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/purchase-program"><img src="assets/images/case/m4.png" alt="case"/></a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/purchase-program"><h3>Tailored Apple Purchase Programs</h3></a>
                                    <p>Discover our customized purchase programs designed to help businesses acquire Apple products with flexible financing options.</p>
                                    <a routerLink="/purchase-program" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/apple-deployment">
                                        <img src="assets/images/deploy&integration.png" alt="deployment"/>
                                        <!-- <div class="icon-wrapper">
                                            <i class="fas fa-cogs"></i>
                                        </div> -->
                                    </a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/apple-deployment"><h3>Seamless Apple Deployment & Integration</h3></a>
                                    <p>Zero-touch Apple deployment with MDM and Business Manager—fast, secure, and seamless. Ideal for startups to enterprise scale-ups, with expert setup and minimal downtime.</p>
                                    <a routerLink="/apple-deployment" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/apple-financing">
                                        <img src="assets/images/finan_flexi.jpeg" alt="financing"/>
                                        <!-- <div class="icon-wrapper">
                                            <i class="fas fa-money-bill-wave fa-4x"></i>
                                        </div> -->
                                    </a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/apple-financing"><h3> Apple Financing & Flexible Payment Plans</h3></a>
                                    <p>Empower your team with Apple tech through flexible leasing and financing. Enjoy predictable costs, easy upgrades, and stress-free scaling.</p>
                                    <a routerLink="/apple-financing" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/apple-maintenance">
                                        <img src="assets/images/compre_supp.jpeg" alt="maintenance"/>
                                        <!-- <div class="icon-wrapper">
                                            <i class="fas fa-cogs fa-4x"></i>
                                        </div> -->
                                    </a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/apple-maintenance"><h3>Comprehensive Apple Maintenance & Support</h3></a>
                                    <p>End-to-end Apple support from certified engineers—onsite or remote. For updates, repairs, and more, we keep your Apple setup running smoothly</p>
                                    <a routerLink="/apple-maintenance" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/apple-training">
                                        <img src="assets/images/training_new.png" alt="training"/>
                                       <!--  <div class="icon-wrapper">
                                            <i class="fas fa-graduation-cap fa-4x"></i>
                                        </div> -->
                                    </a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/apple-training"><h3>Custom Apple Training & Enablement</h3></a>
                                    <p>Boost productivity with tailored Apple training for users, creatives, and IT teams. Onsite or online, learn to create, collaborate, and troubleshoot like a pro</p>
                                    <a routerLink="/apple-training" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/apple-ecosystem">
                                        <img src="assets/images/ecosystemconsult.png" alt="ecosystem"/>
                                        <!-- <div class="icon-wrapper">
                                            <i class="fas fa-sitemap fa-4x"></i>
                                        </div> -->
                                    </a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/apple-ecosystem"><h3>Apple Ecosystem Consulting</h3></a>
                                    <p> Align Apple devices, apps, and workflows with your business goals. From planning to deployment, we deliver secure, scalable solutions that work</p>
                                    <a routerLink="/apple-ecosystem" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-case">
                                <div class="case-img">
                                    <a routerLink="/apple-programscreen">
                                        <img src="assets/images/apple_program.png" alt="program" height="100px"/>
                                        <!-- <div class="icon-wrapper">
                                            <i class="fas fa-star fa-4x"></i>
                                        </div> -->
                                    </a>
                                </div>
            
                                <div class="content">
                                    <a routerLink="/apple-programscreen"><h3>Exclusive Apple Programs</h3></a>
                                    <p>Unlock exclusive Apple benefits for business and education through an authorised artner. Access tools, pricing, and support to grow and achieve more..</p>
                                    <a routerLink="/apple-programscreen" class="line-bnt">Read More -></a>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- New Services Section -->
<!-- <section class="services-section">
    <div class="services-intro">
        <div class="intro-content">
            <h2>Our Services</h2>
            <p>Adding value to every aspect of your business through reliable end-to-end IT solutions.</p>
            <a href="#" class="explore-btn">Explore All Services <i class="fas fa-arrow-right"></i></a>
        </div>
    </div>
    <div class="services-carousel-section bg-color">
        <owl-carousel-o [options]="customOptions" class="services-carousel">
            <ng-template carouselSlide>
                <div class="service-card">
                    <div class="card-image">
                        <img src="assets/images/case/m3.png" alt="Pre-Sales">
                    </div>
                    <div class="card-content">
                        <h3>Apple Pre-Sales Expertise</h3>
                        <p>Our expert team provides comprehensive pre-sales support to help you make informed decisions.</p>
                        <a routerLink="/presales-support" class="learn-more">Know More »</a>
                    </div>
                </div>
            </ng-template>

            <ng-template carouselSlide>
                <div class="service-card">
                    <div class="card-image">
                        <img src="assets/images/case/m7.png" alt="Demos">
                    </div>
                    <div class="card-content">
                        <h3>Apple Demos & Proof of Concept Solutions</h3>
                        <p>Experience our hands-on demonstrations and proof of concept solutions.</p>
                        <a routerLink="/demo" class="learn-more">Know More »</a>
                    </div>
                </div>
            </ng-template>

            <ng-template carouselSlide>
                <div class="service-card">
                    <div class="card-image">
                        <img src="assets/images/case/m8.png" alt="Trade-In">
                    </div>
                    <div class="card-content">
                        <h3>Apple Device Trade-In Program</h3>
                        <p>Upgrade your Apple devices with our convenient trade-in program.</p>
                        <a routerLink="/buy-back" class="learn-more">Know More »</a>
                    </div>
                </div>
            </ng-template>

            <ng-template carouselSlide>
                <div class="service-card">
                    <div class="card-image">
                        <img src="assets/images/case/m6.png" alt="Support">
                    </div>
                    <div class="card-content">
                        <h3>Apple Services with Expert Onsite Support</h3>
                        <p>Our certified technicians provide expert onsite support for all your devices.</p>
                        <a routerLink="/onsite-support" class="learn-more">Know More »</a>
                    </div>
                </div>
            </ng-template>

            <ng-template carouselSlide>
                <div class="service-card">
                    <div class="card-image">
                        <img src="assets/images/case/m5.png" alt="Partnerships">
                    </div>
                    <div class="card-content">
                        <h3>Strategic Partnerships with Leading Brands</h3>
                        <p>We collaborate with top technology brands for comprehensive solutions.</p>
                        <a routerLink="/partnering" class="learn-more">Know More »</a>
                    </div>
                </div>
            </ng-template>

            <ng-template carouselSlide>
                <div class="service-card">
                    <div class="card-image">
                        <img src="assets/images/case/m4.png" alt="Purchase">
                    </div>
                    <div class="card-content">
                        <h3>Tailored Apple Purchase Programs</h3>
                        <p>Discover our customized purchase programs with flexible financing options.</p>
                        <a routerLink="/purchase-program" class="learn-more">Know More »</a>
                    </div>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
</section> -->

<!-- <style>
.services-section {
    display: flex;
    height: 500px;
    margin: 20px;
    border-radius: 10px;
}

.services-intro {
    width: 25%;
    background-color: var(--mainColor);
    padding: 80px 50px;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;
    border-radius: 10px;
}

.services-intro::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('assets/images/shape/1.png') no-repeat center center;
    opacity: 0.1;
    background-size: cover;
}

.intro-content {
    position: relative;
    z-index: 1;
}

.services-intro h2 {
    color: #fff;
    font-size: 42px;
    margin-bottom: 20px;
    font-weight: 700;
}

.services-intro p {
    color: #fff;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 30px;
}

.explore-btn {
    display: inline-flex;
    align-items: center;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    font-weight: 600;
    padding: 12px 30px;
    border: 2px solid rgba(255,255,255,0.3);
    border-radius: 30px;
    transition: all 0.3s ease;
}

.explore-btn i {
    margin-left: 10px;
    transition: transform 0.3s ease;
}

.explore-btn:hover {
    background: #fff;
    color: var(--mainColor);
    border-color: #fff;
}

.explore-btn:hover i {
    transform: translateX(5px);
}

.services-carousel-section {
    width: 75%;
    padding: 80px 30px;
    position: relative;
    padding-bottom: 100px;
}

.services-carousel {
    padding: 0 30px;
    margin: 0 -15px;
}

.service-card {
    border-radius: 10px;
    margin: 15px;
    box-shadow: 0 0 20px rgba(0,0,0,0.08);
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    height: 320px;
    max-width: 300px;
    overflow: hidden;
}

.service-card:hover {
    transform: translateY(-5px);
}

.card-image {
    width: 100%;
    height: 160px;
    /* background: #fef1f2; */
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
    /* border-radius: 10px 10px 0 0; */
}

.card-image img {
    /* width: 80px;
    height: 80px; */
    object-fit: cover;
    transition: all 0.3s ease;
    /* filter: brightness(0) saturate(100%) invert(21%) sepia(66%) saturate(2880%) hue-rotate(341deg) brightness(85%) contrast(88%); */
}



.card-content {
    width: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    flex: 1;
}

.service-card h3 {
    color: #293a5c;
    font-size: 16px;
    margin-bottom: 10px;
    line-height: 1.4;
}

.service-card p {
    color: #7a7e9a;
    font-size: 13px;
    line-height: 1.5;
    margin-bottom: 15px;
    flex: 1;
}

.learn-more {
    color: var(--mainColor);
    font-weight: 600;
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 13px;
    margin-top: auto;
}

.learn-more:hover {
    color: #293a5c;
}

/* Remove navigation arrows */
:host ::ng-deep .owl-nav {
    display: none;
}



/* Responsive Styles */
/* Large Tablets */
@media (max-width: 1200px) {
    .services-section {
        height: auto;
        min-height: 500px;
    }

    .services-intro {
        padding: 50px 30px;
    }

    .services-intro h2 {
        font-size: 36px;
    }

    .services-carousel-section {
        padding: 50px 20px;
    }
}

/* Medium Tablets */
@media (max-width: 991px) {
    .services-section {
        flex-direction: column;
        height: auto;
        margin: 15px;
    }
    
    .services-intro,
    .services-carousel-section {
        width: 100%;
        padding: 40px 20px;
    }
    
    .services-intro {
        border-radius: 10px 10px 0 0;
    }

    .services-carousel-section {
        border-radius: 0 0 10px 10px;
    }
    
    .services-intro h2 {
        font-size: 32px;
        text-align: center;
    }
    
    .services-intro p {
        font-size: 14px;
        text-align: center;
        max-width: 600px;
        margin: 0 auto 20px;
    }

    .explore-btn {
        display: flex;
        justify-content: center;
        max-width: 200px;
        margin: 0 auto;
    }
    
    .service-card {
        height: 300px;
        max-width: 280px;
        margin: 10px auto;
    }
}

/* Small Tablets */
@media (max-width: 768px) {
    .services-section {
        margin: 10px;
    }

    .services-intro {
        padding: 30px 20px;
    }

    .services-intro h2 {
        font-size: 28px;
    }

    .service-card {
        height: 280px;
        max-width: 260px;
    }

    .card-image {
        height: 140px;
    }

    .card-content {
        padding: 15px;
    }

    .service-card h3 {
        font-size: 15px;
    }

    .service-card p {
        font-size: 12px;
    }
}

/* Mobile Devices */
@media (max-width: 576px) {
    .services-section {
        margin: 5px;
    }

    .services-intro {
        padding: 25px 15px;
    }

    .services-intro h2 {
        font-size: 24px;
    }

    .services-intro p {
        font-size: 13px;
        margin-bottom: 15px;
    }

    .explore-btn {
        font-size: 14px;
        padding: 10px 25px;
    }

    .services-carousel-section {
        padding: 30px 15px;
    }

    .service-card {
        height: 260px;
        max-width: 240px;
        margin: 8px auto;
    }

    .card-image {
        height: 120px;
    }

    .card-content {
        padding: 12px;
    }

    .service-card h3 {
        font-size: 14px;
        margin-bottom: 8px;
    }

    .service-card p {
        font-size: 12px;
        margin-bottom: 12px;
    }

    .learn-more {
        font-size: 12px;
    }
}

/* Extra Small Devices */
@media (max-width: 375px) {
    .services-intro h2 {
        font-size: 22px;
    }

    .service-card {
        height: 240px;
        max-width: 220px;
    }

    .card-image {
        height: 110px;
    }
}
</style> -->